var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { TAG_TYPES } from '@app/api/tagTypes';
import { HTTP_METHODS } from '@app/configs/api';
import { INVESTMENTS_ENDPOINTS } from '@app/configs/api/investments';
import { getInvestorLocale } from '@app/utils/getInvestorLocale';
import { baseApi } from './baseApi';
export const investmentsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getMyInvestments: builder.query({
            query: (queryParams) => {
                const { investmentStatuses, loanPurposeIds } = queryParams, otherParams = __rest(queryParams, ["investmentStatuses", "loanPurposeIds"]);
                const params = Object.assign({}, otherParams);
                if (investmentStatuses && investmentStatuses.length > 0) {
                    investmentStatuses.forEach((status, index) => {
                        params[`investmentStatuses[${index}]`] = status;
                    });
                }
                if (loanPurposeIds && loanPurposeIds.length > 0) {
                    loanPurposeIds.forEach((id, index) => {
                        params[`loanPurposeIds[${index}]`] = id;
                    });
                }
                return {
                    url: INVESTMENTS_ENDPOINTS.myInvestments,
                    params,
                };
            },
            transformResponse: (response) => {
                return {
                    items: response.investments,
                    pagination: response.pagination,
                };
            },
            providesTags: [TAG_TYPES.INVESTMENTS],
        }),
        getInvestmentOpportunities: builder.query({
            query: (queryParams) => {
                const { riskScores, purposeIds } = queryParams, otherParams = __rest(queryParams, ["riskScores", "purposeIds"]);
                const params = Object.assign({}, otherParams);
                if (riskScores && riskScores.length > 0) {
                    riskScores.forEach((score, index) => {
                        params[`riskScores[${index}]`] = score;
                    });
                }
                if (purposeIds && purposeIds.length > 0) {
                    purposeIds.forEach((id, index) => {
                        params[`purposeIds[${index}]`] = id;
                    });
                }
                return {
                    url: INVESTMENTS_ENDPOINTS.opportunities,
                    params,
                };
            },
            transformResponse: (response) => {
                return {
                    items: response.offers,
                    pagination: response.pagination,
                };
            },
            providesTags: [TAG_TYPES.OPPORTUNITIES],
        }),
        getOfferDetails: builder.query({
            query: (id) => ({
                url: INVESTMENTS_ENDPOINTS.offerDetails(id),
                params: {
                    locale: getInvestorLocale(),
                },
            }),
            providesTags: (_result, _error, id) => [{ type: TAG_TYPES.OFFER_DETAILS, id }],
        }),
        getMyInvestmentDetails: builder.query({
            query: (id) => ({
                url: INVESTMENTS_ENDPOINTS.myInvestmentDetails(id),
                params: {
                    locale: getInvestorLocale(),
                },
            }),
            providesTags: (_result, _error, id) => [{ type: TAG_TYPES.INVESTMENT_DETAILS, id }],
        }),
        validateInvestmentAmount: builder.mutation({
            query: ({ amount }) => ({
                url: INVESTMENTS_ENDPOINTS.validateAmount,
                method: HTTP_METHODS.POST,
                body: {
                    amount,
                    currency: 'EUR',
                },
            }),
        }),
        submitInvestment: builder.mutation({
            query: (data) => ({
                url: INVESTMENTS_ENDPOINTS.investments,
                method: HTTP_METHODS.POST,
                body: data,
            }),
            invalidatesTags: (result) => !(result === null || result === void 0 ? void 0 : result.error) ? [TAG_TYPES.INVESTMENTS, TAG_TYPES.OPPORTUNITIES, TAG_TYPES.INVESTMENT_PORTFOLIO] : [],
        }),
        getInvestmentPortfolio: builder.query({
            query: () => ({
                url: INVESTMENTS_ENDPOINTS.portfolio,
            }),
            providesTags: [TAG_TYPES.INVESTMENT_PORTFOLIO],
        }),
        getExpectedProfit: builder.query({
            query: ({ id, investmentAmount }) => ({
                url: INVESTMENTS_ENDPOINTS.expectedProfit(id),
                params: {
                    investmentAmount,
                },
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetMyInvestmentsQuery, useGetInvestmentOpportunitiesQuery, useGetOfferDetailsQuery, useGetMyInvestmentDetailsQuery, useValidateInvestmentAmountMutation, useSubmitInvestmentMutation, useGetInvestmentPortfolioQuery, useLazyGetExpectedProfitQuery, } = investmentsApi;
